import { render, staticRenderFns } from "./formPoaAvanceFisico.vue?vue&type=template&id=0c9cb068&"
import script from "./formPoaAvanceFisico.vue?vue&type=script&lang=ts&"
export * from "./formPoaAvanceFisico.vue?vue&type=script&lang=ts&"
import style0 from "./formPoaAvanceFisico.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports